export default __webpack_public_path__ + "98fb9d5e6de8481121e737248e58d95c.png";